import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import Particle from "../Particle";
import { AiOutlineSend, AiOutlineCheckCircle, AiFillGithub } from "react-icons/ai";
import { MdErrorOutline } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";

const INITIAL = { from_name: "", from_email: "", subject: "", message: "" };

function Contact() {
  const [form, setForm]     = useState(INITIAL);
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("sending");

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name:  form.from_name,
          from_email: form.from_email,
          subject:    form.subject,
          message:    form.message,
          to_name:    "Chandraprakash",
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setStatus("success");
        setForm(INITIAL);
      })
      .catch((err) => {
        console.error("EmailJS error:", err);
        setStatus("error");
      });
  };

  return (
    <Container fluid className="contact-section">
      <Particle />
      <Container>
        <Row className="contact-header">
          <Col md={12}>
            <h1 className="project-heading">
              Get In <strong className="purple">Touch</strong>
            </h1>
            <p className="contact-subheading">
              Looking to collaborate or discuss an opportunity? I'd love to hear from you.
            </p>
          </Col>
        </Row>

        <Row className="contact-content" style={{ justifyContent: "center" }}>

          {/* ── Left: info card ── */}
          <Col xs={12} md={4} className="contact-info-col">
            <div className="contact-info-card">
              <h3 className="purple">Let's talk</h3>
              <p>
                I'm currently open to new opportunities — full-time roles,
                freelance projects, or just a technical conversation.
              </p>

              <div className="contact-detail">
                <span className="contact-label">Email</span>
                <a href="mailto:chandraprakashk9589@gmail.com" className="contact-value">
                  chandraprakashk9589@gmail.com
                </a>
              </div>

              <div className="contact-detail">
                <span className="contact-label">Location</span>
                <span className="contact-value">Indore, MP, India</span>
              </div>

              <div className="contact-detail">
                <span className="contact-label">Availability</span>
                <span className="contact-value available">
                  <span className="availability-dot" /> Open to opportunities
                </span>
              </div>

              <div className="contact-socials">
                <a href="https://github.com/chandraprakash9589" target="_blank" rel="noreferrer" className="icon-colour home-social-icons">
                  <AiFillGithub />
                </a>
                <a href="https://www.linkedin.com/in/chandraprakash-kushwaha-a9a672269/" target="_blank" rel="noreferrer" className="icon-colour home-social-icons">
                  <FaLinkedinIn />
                </a>
              </div>
            </div>
          </Col>

          {/* ── Right: form ── */}
          <Col xs={12} md={7} className="contact-form-col">
            <form onSubmit={handleSubmit} className="contact-form">
              <Row>
                <Col xs={12} md={6}>
                  <div className="contact-field">
                    <label htmlFor="from_name">Your Name</label>
                    <input
                      id="from_name"
                      type="text"
                      name="from_name"
                      value={form.from_name}
                      onChange={handleChange}
                      placeholder="John Doe"
                      required
                    />
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div className="contact-field">
                    <label htmlFor="from_email">Your Email</label>
                    <input
                      id="from_email"
                      type="email"
                      name="from_email"
                      value={form.from_email}
                      onChange={handleChange}
                      placeholder="hello@example.com"
                      required
                    />
                  </div>
                </Col>
              </Row>

              <div className="contact-field">
                <label htmlFor="subject">Subject</label>
                <input
                  id="subject"
                  type="text"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  placeholder="Project inquiry / Job opportunity / Just saying hi"
                  required
                />
              </div>

              <div className="contact-field">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell me about your project or opportunity..."
                  rows={6}
                  required
                />
              </div>

              {status === "success" && (
                <div className="contact-feedback success">
                  <AiOutlineCheckCircle /> Message sent! I'll get back to you soon.
                </div>
              )}
              {status === "error" && (
                <div className="contact-feedback error">
                  <MdErrorOutline /> Something went wrong. Please try emailing me directly at chandraprakashk9589@gmail.com
                </div>
              )}

              <button
                type="submit"
                className="contact-submit-btn"
                disabled={status === "sending"}
              >
                {status === "sending" ? (
                  <><span className="contact-spinner" /> Sending...</>
                ) : (
                  <>Send Message &nbsp;<AiOutlineSend /></>
                )}
              </button>
            </form>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;
